import script from "./NotFoundPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NotFoundPage.vue?vue&type=script&setup=true&lang=js"

import "./NotFoundPage.vue?vue&type=style&index=0&id=790e61ae&scoped=true&lang=css"

import exportComponent from "E:\\TestProject Temurako\\e-commerce-app-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-790e61ae"]])

export default __exports__